import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  droneJobs: [],
  loading: false,
  error: null,
  droneJobDetails: {},
  totalPage: 1,
};

const droneJobSlice = createSlice({
  name: 'droneJob',
  initialState,
  reducers: {
    getDroneJobs(state) {
      state.loading = true;
    },
    getDroneJobsSuccess(state, action) {
      state.loading = false;
      state.droneJobs = action.payload.droneJobs;
      state.error = null;
      state.totalPage = action.payload.totalPages;
    },
    getDroneJobsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    getSingleDroneJob(state) {
      state.loading = true;
    },
    getSingleDroneJobSuccess(state, action) {
      state.loading = false;
      state.droneJobDetails = action.payload;
      state.error = null;
    },
    getSingleDroneJobFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getDroneJobs,
  getDroneJobsSuccess,
  getDroneJobsFailure,
  getSingleDroneJob,
  getSingleDroneJobSuccess,
  getSingleDroneJobFailure,
} = droneJobSlice.actions;

export default droneJobSlice.reducer;
